import React from "react";
import Shimmer from "../../../components/Shimmer";
import { useSelector } from "react-redux";

const HeaderShimmer = () => {
  const { megaMenu } = useSelector((state) => state.megaMenuSlice);
  const shimmerHeight = !megaMenu ? "119px" : "284px";

  return <Shimmer width={"100%"} height={shimmerHeight} />;
};

export default HeaderShimmer;
